module.exports = __webpack_public_path__ + "img/caihua_banner_yi.6c81ecb6.png";